import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import Input from '../../../../components/forms/Input'
import { getSetting } from 'utils/SettingUtils'
import { Grid } from '@mui/material'

const UserPasswordPanel = ({
    changePassword = () => {},
    changePasswordAgain = () => {},
}) => {
    const {
        applicationSettings,
    } = useSelector(store => ({
        applicationSettings: store.AdministrationReducer.applicationSettings,
    }), shallowEqual)

    return (
        <Grid container sx={{ marginBottom: '20px' }}>
            <Grid size={12}>
                <p>
                    { getSetting(applicationSettings, 'securityPasswordDescription') }
                </p>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <Input
                            title={i18n.newPassword}
                            passwordType={true}
                            value={''}
                            maxLength={128}
                            onChange={(password) => changePassword(password)}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={i18n.newPasswordAgain}
                            passwordType={true}
                            value={''}
                            maxLength={128}
                            onChange={(passwordAgain) => changePasswordAgain(passwordAgain)}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

UserPasswordPanel.propTypes = {
    changePassword: PropTypes.func,
    changePasswordAgain: PropTypes.func,
}

export default UserPasswordPanel
